<template>
    <!-- ============ MOBILE APP START ============ -->
		<section id="app" class="color2">
			<div class="container">
				<div class="row">
					<div class="col-sm-5">
						<div id="phone"></div>
					</div>
					<div class="col-sm-offset-1 col-sm-6">
						<p>&nbsp;</p>
						<h2>EM BREVE, O WORKIX NO SEU CELULAR</h2>
						<p>Em desenvolvimento: as mesmas vagas, notificações e alertas do site,
							agora numa experiência pensada para o seu celular. Participar continua gratuito, como sempre foi.</p>
						<p>							
							<a href="https://play.google.com/store/apps/details?id=br.com.frmichetti.openjobs.android" class="btn btn-default"><i class="fa fa-android"></i> Android</a>
						</p>
						<p>&nbsp;</p>
					</div>
				</div>
			</div>
		</section>
		<!-- ============ MOBILE APP END ============ -->
</template>

<script>
export default {

}
</script>

<style>

</style>